import { useMemo } from 'react';
import type { EventServerContact } from '@/graphql/types';
import { getEventInfo } from '../utils';
import { EVENT_TYPES } from '../constants';

interface UseEventInfoResult {
    lastContactDate: Date | null;
    lastRecordDate: Date | null;
    lastRecordUploads: unknown;
}

export function useEventInfo(
    events: EventServerContact[] | undefined,
    timezone: string
): UseEventInfoResult {
    return useMemo(() => {
        void timezone;
        const serverContactInfo = getEventInfo(events, EVENT_TYPES.SERVER_CONTACT);
        const lastRecordInfo = getEventInfo(events, EVENT_TYPES.LAST_RECORD);

        return {
            lastContactDate: serverContactInfo.date,
            lastRecordDate: lastRecordInfo.date,
            lastRecordUploads: lastRecordInfo.uploads,
        };
    }, [events, timezone]);
}
